import moment from 'moment';
import React from 'react';
// Allotment of ISBN and ISSN Number
const ThirteenStepWhatsappTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    conference_from_date,
    conference_to_date,
    registration_link,
    your_name,
    contact_details,
  } = values;
  return (
    <div>
      <p>Hi {client_name ? client_name : `[Lead's Name]`},</p>
      <p>
        Great news! ISBN and ISSN numbers are now available for our upcoming{' '}
        <strong>
          {conference_short_name
            ? conference_short_name
            : `[Conference Short Name]`}{' '}
        </strong>
        on{' '}
        <strong>
          {conference_from_date && conference_to_date
            ? `${conference_from_date} - ${conference_to_date}`
            : `[Conference from and to Dates]`}
        </strong>
        . This is a fantastic opportunity to give your research global
        recognition, enhance its visibility, and secure prestigious
        accreditation.
      </p>
      <p>
        Additionally, all accepted and registered papers will have the chance to
        be published in high-impact journals indexed in <strong>Scopus</strong>{' '}
        and <strong>Web of Science (WoS)</strong>, boosting the reach and
        credibility of your work.
      </p>

      <p>
        Our conference is also <strong>CPD accredited</strong>, offering
        valuable professional development.
      </p>

      <p>
        Slots for securing an ISBN or ISSN are limited, so we encourage you to
        register ASAP!
      </p>
      <p>
        {registration_link ? (
          <>
            <strong>Register here: </strong>
            <a
              href={registration_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {registration_link}
            </a>
          </>
        ) : (
          <strong>Register here: [Registration Link]</strong>
        )}
      </p>
      <p>Feel free to reach out if you need any help or clarification.</p>
      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default ThirteenStepWhatsappTemplate;
